'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './headline.component';
import dynamic from 'next/dynamic';

const DynamicHeadlineComponent: ComponentType<Props> = dynamic(
  () => import('./headline.component')
);

export default DynamicHeadlineComponent;

export function calculateHeadlinePlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 162 },
    { sinceWidth: 768, height: 192 }
  ];

  return {
    heightSinceWidth
  };
}
